import { ReactNode } from "react";
export default function GradientSvg({
  children
}: {
  children: ReactNode;
}) {
  return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="GradientSvg" data-sentry-source-file="gradient-svg.tsx">
      <defs data-sentry-element="defs" data-sentry-source-file="gradient-svg.tsx">
        <linearGradient id="Gradient2" x1="0" x2="1" y1="0" y2="0" data-sentry-element="linearGradient" data-sentry-source-file="gradient-svg.tsx">
          <stop offset="0%" stopColor="hsl(var(--gradient-start))" data-sentry-element="stop" data-sentry-source-file="gradient-svg.tsx" />
          <stop offset="100%" stopColor="hsl(var(--gradient-end))" data-sentry-element="stop" data-sentry-source-file="gradient-svg.tsx" />
        </linearGradient>
      </defs>
      {children}
    </svg>;
}